<template>
  <div class="flex flex-col focus-within:ring">
    <template v-for="(title, key, idx) in entries" :key="`title-${key}`">
      <button
        class="overflow-hidden whitespace-nowrap border border-grey-20 px-4 text-left text-lg font-bold leading-[80px]"
        :class="headerClasses(key)"
        tabindex="0"
        :aria-controls="regionId(key)"
        :id="headerId(key)"
        :ref="headerId(key)"
        @click="setActiveKey(key)"
        @keyup.enter.once="setActiveKey(key)"
        @keyup.space.once="setActiveKey(key)"
        @keyup.up.stop="setFocusIdx(idx - 1)"
        @keyup.down.stop="setFocusIdx(idx + 1)"
      >
        <IconChevronRight
          class="transition-100 inline-block h-5 w-5 transition-transform"
          :class="iconClasses(key)"
          role="presentation"
        />
        {{ title }}
      </button>
      <div
        class="transition-100 border border-t-0 border-grey-20 p-4 transition"
        :class="bodyClasses(key)"
        role="region"
        :id="regionId(key)"
        :aria-expanded="activeKey === key"
        :aria-labelledby="headerId(key)"
      >
        <slot :name="`body-${key}`" />
      </div>
    </template>
  </div>
</template>

<script>
import IconChevronRight from 'Components/Icons/IconChevronRight';
import uuid from 'Mixins/uuid';
import selectableSlot from 'Mixins/selectableSlot';

export default {
  name: 'AcAccordion',
  components: { IconChevronRight },
  mixins: [uuid, selectableSlot],
  data() {
    return {};
  },
  methods: {
    regionId(key) {
      return `${this.uuid}-${key}-region`;
    },
    headerId(key) {
      return `${this.uuid}-${key}-header`;
    },
    headerClasses(key) {
      const activeClasses = ['text-blue', 'border-b-0'];
      const inactiveClasses = ['text-blue-30', 'cursor-pointer', 'bg-grey-10'];
      return key === this.activeKey ? activeClasses : inactiveClasses;
    },
    iconClasses(key) {
      const activeClasses = ['text-blue', 'rotate-90'];
      const inactiveClasses = ['text-blue-30'];
      return key === this.activeKey ? activeClasses : inactiveClasses;
    },
    bodyClasses(key) {
      return {
        hidden: key !== this.activeKey,
        block: key === this.activeKey,
      };
    },
    setFocusIdx(idx) {
      const availableKeys = Object.keys(this.entries);
      if (availableKeys.length === 0) {
        return;
      }

      let focusKey;
      if (idx === availableKeys.length) {
        focusKey = availableKeys[0];
      } else if (idx === -1) {
        focusKey = availableKeys[availableKeys.length - 1];
      } else {
        focusKey = availableKeys[idx];
      }
      const focusKeyRef = this.headerId(focusKey);
      const el = this.$refs[focusKeyRef][0];
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.focus();
    },
  },
};
</script>
